var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.tokenId)?_c(_setup.TokenMoney,{attrs:{"value":_vm.value,"token-id":_setup.tokenId,"prefix":_setup.urlPrefix,"data-cy":_vm.dataCy,"round":_vm.round,"inline":""}}):_c(_setup.Money,{attrs:{"value":_vm.value,"data-cy":_vm.dataCy,"inline":"","round":_vm.round}})
}
var staticRenderFns = []

export { render, staticRenderFns }